<template>
  <div v-if="exam_details.is_simulation === 1 && exam_details.show_progress_bar === 1" class="exam-reviews">

      <h2>Progress</h2>

      <p>You will be exposed to more concepts and gain a higher level of fluency by taking more exams and getting higher scores in them. This is a rough estimate of your current fluency:</p>

      <progress-bar :value="progress.fluency" :max="100" :min="0" />

  </div>
</template>

<script>
import ProgressBar from './../Common/ProgressBar'
import { mapState } from 'vuex'

export default {
  name: 'DashboardProgress',
  computed: {
    ...mapState('exam', ['exam_details', 'progress'])
  },
  components: {
    ProgressBar
  }
}
</script>
